import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CosingSearchRequest, CosingService } from 'src/app/_services/cosing.service';
import { HammaddeService } from 'src/app/_services/hammadde.service';
import { CosingResponse, Result } from 'src/app/models/cosingresponse';
import { ToastrService } from 'ngx-toastr';
import { Editor, Toolbar } from 'ngx-editor';
@Component({
  selector: 'app-addhammadde',
  templateUrl: './addhammadde.component.html',
  styleUrls: ['./addhammadde.component.css']
})
export class AddhammaddeComponent implements OnInit {
  submitted=false;
  definitionForm:FormGroup;
  cosingResult:CosingResponse;
  page=1; 
   editor2a:Editor;
   editor2b:Editor;

     toolbar: Toolbar = [
       ['bold', 'italic'],
       ['underline', 'strike'],
       ['code', 'blockquote'],
       ['ordered_list', 'bullet_list'],
       [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
       ['link', 'image'],
       ['text_color', 'background_color'],
       ['align_left', 'align_center', 'align_right', 'align_justify'],
     ];
  
  @Input() hammadde:any;
  constructor(
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private hammaddeService:HammaddeService,
    private cosing:CosingService,
    private toastr: ToastrService
    
  ) { }

  ngOnInit() {
  this.editor2a=new Editor();
  this.editor2b=new Editor();
    this.definitionForm=this.formBuilder.group({
      'name':[''],
      'inciName':[''],
      'cas':[''],
      'einecs':[''],
      'function':[''],
      'noael':[''],
      'references':[''],
      'toksicology':[''],
      'cosingId':[],
      'annex':[]
    });

    if(this.hammadde){
      this.definitionForm.get("cosingId").patchValue(this.hammadde.cosingId);
      this.definitionForm.get("name").patchValue(this.hammadde.name);
      this.definitionForm.get("inciName").patchValue(this.hammadde.inciName);
      this.definitionForm.get("cas").patchValue(this.hammadde.cas);
      this.definitionForm.get("einecs").patchValue(this.hammadde.einecs);
      this.definitionForm.get("function").patchValue(this.hammadde.function);
      this.definitionForm.get("noael").patchValue(this.hammadde.noael);
      this.definitionForm.get("references").patchValue(this.hammadde.references);
      this.definitionForm.get("toksicology").patchValue(this.hammadde.toksicology);
      this.definitionForm.get("annex").patchValue(this.hammadde.annex);
    }
  }


  close(){
    this.activeModal.close();
  }


  save(){
    if(!this.definitionForm.valid){
      this.definitionForm.markAllAsTouched();
     
      return;
    }
    this.submitted=true;


    var model={
      cosingId:this.definitionForm.get("cosingId").value,
      name:this.definitionForm.get("name").value,
      inciName:this.definitionForm.get("inciName").value??"",
      cas:this.definitionForm.get("cas").value??"",
      einecs:this.definitionForm.get("einecs").value??"",
      function:this.definitionForm.get("function").value??"",
      noael:this.definitionForm.get("noael").value??"",
      references:this.definitionForm.get("references").value??"",
      toksicology:this.definitionForm.get("toksicology").value??"",
      annex:this.definitionForm.get("annex").value??"",

    }

    if(this.hammadde){
      //update
      const updatedModel = { ...model, id: this.hammadde.id };
      this.hammaddeService.editHammadde(updatedModel,this.hammadde.id).subscribe(res=>{
        this.submitted=false;
        this.toastr.clear();
        this.toastr.success('', 'Kayıt güncelleme başarılı');
        this.definitionForm.reset();
        this.cosingResult=null;
      },err=>{
        this.toastr.error('', 'Kayıt güncelleme sırasında hata oluştu');
        this.submitted=false;
      });
    }
    else{
      //insert
      this.hammaddeService.addHammadde(model).subscribe(res=>{
        this.submitted=false;
        this.toastr.clear();
        this.toastr.success('', 'Kayıt başarılı');
        this.definitionForm.reset();
        this.cosingResult=null;
      },err=>{
        this.toastr.error('', 'Kayıt sırasında hata oluştu, bu hammadde sistemde var mı kontrol edin');
        this.submitted=false;
      });
    }
  
  }

  searchAndPush(){

    var name="abcdefghijklmnopqrstuvwxyz";

    for(var i=0;i<name.length;i++){
      this.cosingResult=null;


      var cosingdata={"bool":{"must":[{"text":{"query":name[i],"fields":["inciName.exact","inciUsaName","innName.exact","phEurName","chemicalName","chemicalDescription"],"defaultOperator":"AND"}},{"terms":{"itemType":["ingredient","substance"]}}]}}
     
     
      this.cosing.search(cosingdata,1).subscribe(res=>{

        var data={name:JSON.stringify(res)};
      

         this.cosing.addHammadde(data).subscribe(dar=>{
         
         },err=>{
          console.log(err);
         });


         if(res.results.length>0){

         
          var pagecount=res.totalResults/200;

          for(var j=2;j<=pagecount;j++){
            this.cosing.search(cosingdata,j).subscribe(res=>{

              var data={name:JSON.stringify(res)};
              this.cosing.addHammadde(data).subscribe(dar=>{
              },err=>{
                console.log(err);
              });
            });
          }


        }



      },err=>{
         
      });
    }


   


     
     

 


  }

  search(){
    this.cosingResult=null;
      var name=this.definitionForm.get("name").value;
      var cosingdata={"bool":{"must":[{"text":{"query":name,"fields":["inciName.exact","inciUsaName","innName.exact","phEurName","chemicalName","chemicalDescription"],"defaultOperator":"AND"}},{"terms":{"itemType":["ingredient","substance"]}}]}}
      

      console.log(cosingdata);

      this.cosing.search(cosingdata,1).subscribe(res=>{
        console.log(res);
          this.cosingResult=res;
         
      },err=>{
          console.log(err);
      });
  }

  select(d){

    this.definitionForm.get("cosingId").patchValue(d.metadata.substanceId[0]);
    this.definitionForm.get("inciName").patchValue(d.metadata.inciName[0]);
    this.definitionForm.get("cas").patchValue(d.metadata.casNo[0]);
    this.definitionForm.get("einecs").patchValue(d.metadata.ecNo[0]);
    this.definitionForm.get("function").patchValue(d.metadata.functionName.join(','));
    this.cosingResult=null;
  }
}
